import {
  authRemoteDataSource,
  type AuthorizeParams,
  type AuthorizeResponse,
  type CheckSessionsResponse,
  type ClientValidationResponse,
  type LoginParams,
  type LoginResponse,
  type RequestOtpParams,
  type RequestOtpResponse,
  type VerifyOtpParams,
  type VerifyOtpResponse,
} from "../datasources/authRemoteDataSource";

export class AuthRepository {
  async validateClient(clientId: string, redirectUri: string): Promise<ClientValidationResponse> {
    return await authRemoteDataSource.validateClient({
      clientId,
      redirectUri,
    });
  }

  async login(params: LoginParams): Promise<LoginResponse> {
    return await authRemoteDataSource.login(params);
  }

  async requestOtp(params: RequestOtpParams): Promise<RequestOtpResponse> {
    return await authRemoteDataSource.requestOtp(params);
  }

  async verifyOtp(params: VerifyOtpParams): Promise<VerifyOtpResponse> {
    return await authRemoteDataSource.verifyOtp(params);
  }

  async authorize(params: AuthorizeParams): Promise<AuthorizeResponse> {
    return await authRemoteDataSource.authorize(params);
  }

  async checkSessions(userIds: string[]): Promise<CheckSessionsResponse> {
    return await authRemoteDataSource.checkSessions(userIds);
  }
}

export const authRepository = new AuthRepository();
